export default "__VITE_ASSET__509f9c63__"